import {createApp} from 'vue'
import PersonalFundraisingListItem from './PersonalFundraisingListItem'

const el = '.kb-component--personal-fundraising-list-item'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((itemDOM)=>{
            const name = itemDOM.dataset.name || ''
            const amount = Number.parseInt(itemDOM.dataset.amount, 10) || 0
            const url = itemDOM.dataset.url || null
            const component = createApp(PersonalFundraisingListItem, {
                name,
                amount,
                url
            }).use(Store)
            component.mount(itemDOM)
        })
    }
}
